import styled from "styled-components";

const Button = styled.pre`
    border: none;
    outline: none;
    padding: 1em;
    :hover {
        cursor: pointer;
    }
    text-align: center;
`;

export default Button;
